import React from "react";
import classNames from "classnames";
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavLink,
  Nav,
  Container,
  NavbarToggler,
} from "reactstrap";
import { useAuth } from "contexts/AuthContext";

function AdminNavbar(props) {
  const { user, logout } = useAuth();
  const [collapseOpen, setcollapseOpen] = React.useState(false);
  const [color, setcolor] = React.useState("navbar-transparent");

  React.useEffect(() => {
    window.addEventListener("resize", updateColor);
    return function cleanup() {
      window.removeEventListener("resize", updateColor);
    };
  });

  const updateColor = () => {
    if (window.innerWidth < 993 && collapseOpen) {
      setcolor("bg-white");
    } else {
      setcolor("navbar-transparent");
    }
  };

  const toggleCollapse = () => {
    if (collapseOpen) {
      setcolor("navbar-transparent");
    } else {
      setcolor("bg-white");
    }
    setcollapseOpen(!collapseOpen);
  };

  const getUserName = () => {
    try {
      if (user?.token) {
        const payload = JSON.parse(atob(user.token.split(".")[1]));
        return payload?.data?.nombreusuario || "Admin";
      }
    } catch {
      // ignore decode errors
    }
    return "Admin";
  };

  const getInitials = (name) => {
    return name.slice(0, 2).toUpperCase();
  };

  const userName = getUserName();

  return (
    <Navbar className={classNames("navbar-absolute", color)} expand="lg">
      <Container fluid>
        <div className="navbar-wrapper">
          <div
            className={classNames("navbar-toggle d-inline", {
              toggled: props.sidebarOpened,
            })}
          >
            <NavbarToggler onClick={props.toggleSidebar}>
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </NavbarToggler>
          </div>
          <NavbarBrand href="#pablo" onClick={(e) => e.preventDefault()}>
            {props.brandText}
          </NavbarBrand>
        </div>
        <NavbarToggler onClick={toggleCollapse}>
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
        </NavbarToggler>
        <Collapse navbar isOpen={collapseOpen}>
          <Nav className="ml-auto" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle
                caret
                color="default"
                nav
                onClick={(e) => e.preventDefault()}
              >
                <div
                  className="photo"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "linear-gradient(135deg, #1d8cf8, #3358f4)",
                    borderRadius: "50%",
                    width: "33px",
                    height: "33px",
                    fontSize: "12px",
                    fontWeight: 700,
                    color: "#fff",
                    letterSpacing: "0.5px",
                  }}
                >
                  {getInitials(userName)}
                </div>
                <b className="caret d-none d-lg-block d-xl-block" />
                <p className="d-lg-none">Cerrar sesión</p>
              </DropdownToggle>
              <DropdownMenu className="dropdown-navbar" end tag="ul">
                <NavLink tag="li">
                  <DropdownItem
                    className="nav-item"
                    header
                    style={{ fontWeight: 600, opacity: 0.7, fontSize: "12px" }}
                  >
                    {userName}
                  </DropdownItem>
                </NavLink>
                <DropdownItem divider tag="li" />
                <NavLink tag="li">
                  <DropdownItem className="nav-item" onClick={logout}>
                    <i className="tim-icons icon-button-power mr-2" />
                    Cerrar sesión
                  </DropdownItem>
                </NavLink>
              </DropdownMenu>
            </UncontrolledDropdown>
            <li className="separator d-lg-none" />
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default AdminNavbar;
